<template>
  <div class="level-radio-grid">
    <label
      v-for="item in options"
      :key="item.id"
      class="level-radio-option"
      :class="{ 'level-radio-option--active': value === item.id }"
    >
      <!-- radio asli (disembunyikan tapi area klik 1 kartu penuh) -->
      <input
        type="radio"
        class="level-radio-input"
        :value="item.id"
        :name="name"
        :checked="value === item.id"
        @change="$emit('input', item.id)"
      />

      <span class="level-radio-circle"></span>

      <div class="level-radio-text">
        <p class="level-radio-main">
          {{ item.title_category }}
        </p>
        <p class="level-radio-sub">
          ({{ item.subtitle_category }})
        </p>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'LevelRadioGroup',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
     name: {
      type: String,
      default: 'struktur-level'
    }
  }
}
</script>

<style scoped>
.level-radio-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

/* kartu */
.level-radio-option {
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 40px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  transition: 0.15s ease;
}

.level-radio-option--active {
  border-color: #262298;
  box-shadow: 0 0 0 1px rgba(38, 34, 152, 0.15);
  background: #f6f7ff;
}

.level-radio-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.level-radio-circle {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid #262298;
  box-sizing: border-box;
}

.level-radio-input:checked + .level-radio-circle {
  border-width: 6px;
}

.level-radio-text {
  display: flex;
  flex-direction: column;
}

.level-radio-main {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: -4px;
}

.level-radio-sub {
  font-size: 12px;
  color: #6b7280;
}

.divider {
  height: 1px;
  color: black;
  width: 100%
}

/* responsive: jadi 1 kolom di layar kecil */
@media (max-width: 640px) {
  .level-radio-grid {
    grid-template-columns: 1fr;
  }
}
</style>
